<template>

<component-module moduleName="inventory_module">
    <template v-slot:programName>Inventory</template>
    <template v-slot:navigation>
        <div class="main-nav">
            <template v-if="dashboardMenuItem">
                <div v-if="dashboardMenuItem.not_allowed" class="not-allowed">Dashboard</div>
                <router-link v-else class="link" :to="'/' + dashboardMenuItem.link_value">Dashboard</router-link>
            </template>
            <template v-for="(menuItem) in mainMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-list"></i> Product Specs</div>
            <template v-for="(menuItem) in productSpecsMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-box"></i> Inventory Management</div>
            <template v-for="(menuItem) in inventoryManagementMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>

        </div>
    </template>

    <template v-slot:settings>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-cog"></i> Settings</div>
            <template v-for="(menuItem) in settingsMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
            <!-- <div class="menu-nav-extra">
                <router-link class="link" to="/legacy/receiveinventorymaintenance.php" key="sub-menu-item-legacy-1">Legacy Receive Inventory</router-link>
                <router-link class="link" to="/legacy/calibermaintenance.php" key="sub-menu-item-legacy-1">Legacy Calibers</router-link>
                <router-link class="link" to="/legacy/manufacturermaintenance.php" key="sub-menu-item-legacy-1">Legacy Manufacturers</router-link>
            </div> -->
            <router-link to="/help-center/articles/5" class="link menu-nav-extra">Help Center <i class="fa fa-chevron-right" /> Inventory</router-link>
        </div>
    </template>

</component-module>

</template>

<script>
import './inventory.scss'
export default {
    created() {
        this.updateCustomModuleName('Inventory');
    },
    computed: {
        mainMenu() {
            if (!this.getModuleNavMenu.sort_0) return {}
            return this.getModuleNavMenu.sort_0.menu_items
        },
        productSpecsMenu() {
            if (!this.getModuleNavMenu.sort_1) return {}
            return this.getModuleNavMenu.sort_1.menu_items
        },
        inventoryManagementMenu() {
            if (!this.getModuleNavMenu.sort_2) return {}
            return this.getModuleNavMenu.sort_2.menu_items
        },
        settingsMenu() {
            if (!this.getModuleNavMenu.sort_3) return {}
            return this.getModuleNavMenu.sort_3.menu_items
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'inventory') {
                    return menuItem
                }
            }
        }
    },
    methods: {
        notAllowed(menuItemId) {
            if (menuItemId in this.getMenuItemPolicies && this.getMenuItemPolicies[menuItemId].not_allowed) {
                return true
            }
            return false
        }
    }
}
</script>
